import React from 'react';
import { useSelector } from 'react-redux';

const Loader = ({ isLoading, loadingMessage = '' }) => {
  const { loading } = useSelector((state) => state?.loader);

  if (isLoading ? isLoading : loading)
    return (
      <div className="loader-container">
        <div className="loader"></div>
        {loadingMessage && <p>{loadingMessage}</p>}
      </div>
    );
};

export default Loader;
